import { render } from "./GalleryInput.vue?vue&type=template&id=6f9ccc3c"
import script from "./GalleryInput.vue?vue&type=script&lang=js"
export * from "./GalleryInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__